export enum DefaultOptionType {
  None   = 1,
  Option = 2
}